exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollX {\n  overflow-x: auto !important; }\n\n.portfolio_input {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center; }\n  .portfolio_input div input {\n    border: transparent;\n    border-bottom: 1px solid #abaeb8;\n    max-width: 150px; }\n  .portfolio_input div:first-child {\n    margin-right: 20px; }\n  @media only screen and (max-width: 375px) {\n    .portfolio_input div input {\n      max-width: 100px; } }\n\n.performance_download_btn {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n  justify-content: flex-end; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/PortfolioDashboard/navigationPages/performance/performance.scss
// module id = 1443
// module chunks = 0